var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "elabel-edit"
  }, [_c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['background', 'color'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }), _c('v-text-field', {
    staticClass: "text-field mt-2 pt-5 px-2",
    attrs: {
      "hide-details": "",
      "placeholder": "View u-label data",
      "label": _vm.$t('button_text')
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }